const getLinkTarget = (aemTarget: string) => {
  return aemTarget === "sameWindow" ? "_self" : "_blank";
};

export { getLinkTarget };
